/**
 * Date Formatter Utility
 */

/**
 * Formatea una fecha en el formato YYYY-MM-DD-HH-MM-SS
 * @param date - Fecha a formatear (por defecto: fecha actual)
 * @returns String con formato YYYY-MM-DD-HH-MM-SS
 */
export const formatTimestamp = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  
  return `${year}-${month}-${day}-${hours}-${minutes}-${seconds}`;
};
